import { APP_BUILD, APP_VERSION } from "../productEducation/config/appRelease";

export function getAppVersionDisplay() {
  return {
    version: APP_VERSION,
    build: APP_BUILD,
  };
}

export function formatAppVersionLabel({ version, build } = getAppVersionDisplay()) {
  const versionLine = `Version ${version || "—"}`;
  if (build) {
    return `${versionLine}\nBuild ${build}`;
  }
  return versionLine;
}
